export function partialEnum<T extends object>(enumeration: T, ...keys: (keyof T)[]): T {
    const result: T = {} as T;
    for (const key of keys) {
        result[key] = enumeration[key];
    }

    return result;
}
